import styled from 'styled-components'
import { TrashIcon } from 'components/Icons'

export default styled(TrashIcon)`
  align-self: center;
  flex: 0 0 auto;
  color: #c4c4c4;
`
